import {
	AuthRoutes,
	createAuthSetup,
	Provider,
	User as NFAUser,
	UserPermissions,
} from '@next-firebase/auth';

import { UserSubscription } from 'models/Subscription';
import { UserOnboarding } from 'models/UserTrait';
import { app } from './app';
import { routes } from './routes';

//
// Types & user roles definitions
export enum UserRoles {
	user = 'Usuário',
	admin = 'Administrador',
}

export type UserRole = keyof typeof UserRoles;

export interface User extends NFAUser<UserRole> {
	githubURL?: string;
	publicProfile?: boolean;

	subscription?: UserSubscription;
	onboarding?: UserOnboarding;
}

//
// Routes & permissions
export const privateRoutes: AuthRoutes = [routes.from('dashboard')];

export const permissions: Record<UserRole, UserPermissions<UserRole>> = {
	user: {
		role: 'user',
		mainRoute: routes.get('dashboard'),
		allowedRoutes: [routes.from('dashboard')],
		restrictedRoutes: [routes.from('admin')],
	},
	admin: {
		role: 'admin',
		mainRoute: routes.get('admin'),
		allowedRoutes: [routes.from('admin')],
		restrictedRoutes: [routes.from('dashboard')],
	},
};

//
// Shareable Setup
export const setup = createAuthSetup<UserRole>({
	appId: app.id,
	roles: UserRoles,
	privateRoutes,
	permissions,
	signInPageUrl: routes.get('auth.login'),
});

// Utils, maps, etc
export const providerMap: Record<Provider, string> = {
	'email/password': 'E-mail e senha',
	google: 'Google',
	github: 'GitHub',
	email: 'E-mail',
	anonymous: 'Anônimo',
};
